import trackClevertapEvents from "@/utils/trackClevertapEvents";
import { Toast } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";

import { updateUserProfileVisibility } from "@/components/settings/api/networkUtils";
import HeaderContentToggle from "@/components/settings/components/common/HeaderContentToggle";
import ToggleOffInfoPopUp from "@/components/settings/components/common/ToggleOffInfoPopUp";
import { useProfileData } from "@/components/settings/contents/profileSettings";
import { ProfileVisibilityProps } from "@/components/settings/types/setting";

const ProfileVisibility: React.FC<ProfileVisibilityProps> = ({
  isMobile,
  personalDetails,
}) => {
  const [profileVisibilityToggleValue, setProfileVisibilityToggleValue] =
    useState<boolean>(false);
  const [showDisableInfoPopUp, setShowDisableInfoPopUp] = useState(false);
  const [toast, setToast] = useState({ text: "", type: "", show: false });
  const {
    successToastOnMsg,
    successToggleOffMsg,
    toastErrorMsg,
    profileHeading,
    infoPopUpMainHeadingMessage,
    infoPopUpMessages,
    profileContent,
    secondaryBtnLabel,
  } = useProfileData?.profileVisibility || {};

  useEffect(() => {
    if (personalDetails) {
      const visibility =
        personalDetails?.personalDetailSection?.personalDetails
          ?.profileVisibility;
      setProfileVisibilityToggleValue(visibility ?? true);
    }
  }, [personalDetails]);

  const showToast = (text: string, type: string) => {
    setToast({ text, type, show: true });
  };

  const handleVisibilityUpdate = async (newToggleValue: boolean) => {
    try {
      const data = await updateUserProfileVisibility(newToggleValue);
      if (data) {
        trackClevertapEvents.eventPush("Settings Updated", {
          profileVisibility: newToggleValue ? "Enabled" : "Disabled",
        });
        setProfileVisibilityToggleValue(newToggleValue);
        const message = newToggleValue
          ? successToastOnMsg
          : successToggleOffMsg;
        showToast(message, "success");
      }
    } catch (error) {
      showToast(toastErrorMsg, "error");
    }
  };

  const handleProfileVisibilityToggle = () => {
    const newToggleValue = !profileVisibilityToggleValue;
    if (profileVisibilityToggleValue) {
      setShowDisableInfoPopUp(true);
    } else {
      handleVisibilityUpdate(newToggleValue);
    }
  };

  const handleCloseModal = () => {
    setShowDisableInfoPopUp(false);
  };

  const handleToggleOff = () => {
    setShowDisableInfoPopUp(false);
    handleVisibilityUpdate(false);
  };

  return (
    <div className="bg-surface-secondary flex flex-col rounded-xl p-3">
      <HeaderContentToggle
        heading={profileHeading}
        content={[profileContent]}
        showToggle={true}
        name="auto-apply"
        isToggleChecked={profileVisibilityToggleValue}
        setToggleVisibility={handleProfileVisibilityToggle}
      />
      <Toast
        timer={3000}
        showToast={toast.show}
        text={toast.text}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
        width={isMobile ? "75" : "50"}
        position="top-center"
      />
      <ToggleOffInfoPopUp
        mobileHeading={profileHeading}
        showModal={showDisableInfoPopUp}
        handleCloseModal={handleCloseModal}
        handleToggleOff={handleToggleOff}
        secondaryBtnLabel={secondaryBtnLabel}
        mainHeadingMessage={infoPopUpMainHeadingMessage}
        infoMessages={infoPopUpMessages}
      />
    </div>
  );
};

export default ProfileVisibility;
